/**
 * Shown when the request Host is a tenant subdomain that does NOT resolve to a
 * real tenant (ADR-0036 item #6) — a typo or a never-provisioned slug. A tenant
 * that EXISTS but is suspended gets {@link TenantSuspended} instead. Replaces the
 * misleading operator login (which would silently land on the default `public`).
 */
import { Building2 } from "lucide-react";

export function TenantNotFound({ slug }: { slug?: string | null }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-xl border border-border/60 bg-surface p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <Building2 className="h-6 w-6 text-muted-foreground" strokeWidth={1.5} />
        </div>
        <h1 className="text-lg font-semibold text-foreground">Tenant non trovato</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {slug ? (
            <>
              Nessuna organizzazione attiva per <span className="font-mono text-foreground">{slug}</span>.
            </>
          ) : (
            <>Questo indirizzo non corrisponde a nessuna organizzazione.</>
          )}
        </p>
        <p className="mt-4 text-xs text-muted-foreground">
          Controlla il sottodominio, oppure contatta l'amministratore della piattaforma.
        </p>
      </div>
    </div>
  );
}
